import { Menu, Phone } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { BrandMark } from "./BrandMark";
import { LINKS, STORE } from "@/lib/store";

const NAV = [
  { href: "#catalogue", label: "Products" },
  { href: "#story", label: "Our Story" },
  { href: "#visit", label: "Visit Us" },
];

export const Header = () => (
  <header className="sticky top-0 z-40 border-b border-[#E5E0D8] bg-[#FDFBF7]/90 backdrop-blur-md" data-testid="site-header">
    <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-2.5 sm:px-6 lg:px-8">
      <div className="flex items-center gap-2 md:gap-8">
        <Sheet>
          <SheetTrigger asChild>
            <button className="md:hidden grid h-11 w-11 place-items-center rounded-full border border-[#E5E0D8] text-[#1B4332]" aria-label="Open menu" data-testid="mobile-menu-btn">
              <Menu className="h-5 w-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="bg-[#FDFBF7]" data-testid="mobile-menu">
            <SheetTitle className="font-display text-2xl text-[#1B4332]">Namaste</SheetTitle>
            <nav className="mt-8 flex flex-col gap-1">
              {NAV.map((n) => (
                <a key={n.href} href={n.href} className="rounded-lg px-3 py-3 text-lg font-medium text-[#1F2421] hover:bg-[#F4EEE2]" data-testid={`mobile-nav-${n.label.toLowerCase().replace(" ", "-")}`}>{n.label}</a>
              ))}
              <a href={LINKS.callPrimary} className="mt-6 flex items-center gap-2 px-3 text-[#1B4332]"><Phone className="h-4 w-4" /> {STORE.whatsappDisplay}</a>
            </nav>
          </SheetContent>
        </Sheet>
        <span className="hidden lg:inline font-deva text-lg text-[#8B5A2B]" aria-hidden>नमस्ते</span>
        <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-[#1F2421]">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} className="relative py-1 transition-colors hover:text-[#1B4332] after:absolute after:inset-x-0 after:-bottom-0.5 after:h-px after:origin-left after:scale-x-0 after:bg-[#C59B27] after:transition-transform hover:after:scale-x-100" data-testid={`nav-${n.label.toLowerCase().replace(" ", "-")}`}>{n.label}</a>
          ))}
          <a href={LINKS.callPrimary} className="flex items-center gap-1.5 text-[#1B4332]" data-testid="header-call-link"><Phone className="h-4 w-4" />{STORE.whatsappDisplay}</a>
        </nav>
      </div>
      <BrandMark />
    </div>
  </header>
);
